import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortAsc = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.843 7.06a1.05 1.05 0 0 0-.702 0 .86.86 0 0 0-.308.202l-3.592 3.552A.75.75 0 0 0 8 11.36q0 .31.241.55a.8.8 0 0 0 .556.22q.315 0 .525-.213l2.4-2.372v6.686q0 .327.223.547t.553.221.554-.218a.73.73 0 0 0 .223-.54V9.546l2.39 2.362q.24.24.545.23a.82.82 0 0 0 .546-.227q.24-.24.244-.542a.71.71 0 0 0-.228-.53l-3.618-3.577a.84.84 0 0 0-.311-.202"
	})
});
export default SvgSortAsc;
